import { render, staticRenderFns } from "./exclusiveProducts.vue?vue&type=template&id=12fef6d4&scoped=true&"
import script from "./exclusiveProducts.vue?vue&type=script&lang=js&"
export * from "./exclusiveProducts.vue?vue&type=script&lang=js&"
import style0 from "./exclusiveProducts.vue?vue&type=style&index=0&id=12fef6d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fef6d4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VFlex,VLayout})
